import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";

const mapStateToProp = ({ auth: { isAuth, role } }) => ({
  isAuth,
  role
});

export default connect(mapStateToProp, null)(PrivateRoute);
